// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6f6c1aa3","43":"060fde25","408":"a3d220f7"}[chunkId] + ".chunk.js";
};